import { useMemo } from 'react';
import { BasicDoc, Hit } from 'react-instantsearch-core';
import { AlgoliaProductType } from '$features/productsList/types';
import { useFranchise } from '$shared/utils';
import { useRouter } from 'next/router';

export const useSchemaMarkupCollectionPage = (
    hits: Hit<BasicDoc & AlgoliaProductType>[]
): string | null => {
    const { query } = useRouter();
    const { activeMarket, host, key } = useFranchise();
    const pageQueryParam = query['page'];

    const collectionPageSchema = useMemo((): string | null => {
        if (!hits || hits.length < 1 || pageQueryParam) {
            return null;
        }

        const itemListElement = hits.map((hit, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            item: {
                '@type': 'Product',
                productId: hit.productId,
                name: hit.name,
                url: `https://${host}${
                    [8, 10, 100].includes(key) ? '' : '/' + activeMarket?.locale
                }${hit.productUrl}`,
                image: hit.images?.[0]?.url,
                brand: {
                    '@type': 'Brand',
                    name: hit.brand,
                },
                category: hit.masterCategory,
                description: hit.metaDescription,
                offers: {
                    '@type': 'Offer',
                    availability: 'InStock',
                    price: hit.price,
                    priceCurrency: activeMarket?.currency,
                },
            },
        }));

        return JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            mainEntity: {
                '@type': 'ItemList',
                numberOfItems: hits.length,
                itemListElement,
            },
        });
    }, [key, hits, activeMarket?.locale, host, activeMarket?.currency, pageQueryParam]);

    return collectionPageSchema;
};
